import React from "react";
import { Navigate } from "react-router";

const Conflict = () => {
  return <Navigate to={'/'} />;
};

export default Conflict;
